import requests from "./httpService";


const PaymentDetailsServices = {

 paymentDetailsList: async (type) => {
  
    return requests.get(`/razpaydetails/list/${type}`);
  },
  getallIdPayment: async (id) => {
  
    return requests.get(`/razpaydetails/${id}`);
  },
  getPaymentByOrder: async (id) => {
  
    return requests.get(`/razpaydetails/orders/${id}/payments`);
  },

};

export default PaymentDetailsServices;
